import { CheckCircleIcon } from "lucide-react";
import "./verification-display-card-wide.css";
export const VerificationDisplayCardWide = ({
  heading,
  img,
  link,
  subHeading,
  verificationBlips,
  gradientBottom = false,
}) => {
  return (
    <div className="r2-verification-card-wide">
      <div className="r2-verification-card-wide__panel">
        <div className="r2-verification-card-wide__grid">
          <div>
            <h2 className="r2-verification-card-wide__title">
              {heading}
            </h2>

            <p className="r2-verification-card-wide__subtitle">
              {subHeading}
            </p>

            <div className="r2-verification-card-wide__list">
              {verificationBlips.map((copy, _index) => (
                <div key={copy.point}>
                  <div className="r2-verification-card-wide__item">
                    <CheckCircleIcon className="r2-verification-card-wide__icon" />
                    <span className="r2-verification-card-wide__item-text">
                      {copy.point}
                    </span>
                  </div>
                  {copy.subscript && (
                    <div className="r2-verification-card-wide__subscript">
                      <sup className="r2-verification-card-wide__subscript-index">
                        {copy.subscript.num}
                      </sup>
                      {copy.subscript.text}
                    </div>
                  )}
                </div>
              ))}
            </div>
            {link}
          </div>
          {img}
        </div>
      </div>
    </div>
  );
};
